import { Box, MenuItem } from '@mui/material';
import { CustomButton, CustomSelect, HorizontalForm } from '../../../common';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const PaymentProviderSelector = ({
  value,
  onChange,
  providers,
  selectedFile,
  onFileUpload,
  fileInputRef,
  handleVerify,
}) => {
  return (
    <HorizontalForm sx={{ alignItems: 'center', display: 'block' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ mt: 2 }}>Proveedor cobro:</Box>
        <CustomSelect
          sx={{ width: '200px', marginLeft: '10px' }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          size="medium"
        >
          {providers.map((provider) => (
            <MenuItem key={provider.value} value={provider.value}>
              {provider.label}
            </MenuItem>
          ))}
        </CustomSelect>
        <input
          type="file"
          accept=".txt"
          onChange={onFileUpload}
          style={{ display: 'none' }}
          ref={fileInputRef}
          id="fileUpload"
        />
        <label htmlFor="fileUpload">
          <CustomButton
            sx={{ marginTop: '10px', marginLeft: '20px' }}
            variant="base"
            component="span"
            buttonIcon={FileUploadIcon}
          >
            Seleccionar archivo
          </CustomButton>
        </label>
        <Box
          sx={{
            fontSize: '15px',
            ml: 3,
            mt: 1,
          }}
        >
          {selectedFile ? selectedFile.name : 'Sin archivos seleccionados'}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, justifyContent: "center" }}>
        <CustomButton variant="base" onClick={handleVerify} fullWidth>
          Generar Archivo
        </CustomButton>
      </Box>
    </HorizontalForm>
  );
};

export default PaymentProviderSelector;
